import { render, staticRenderFns } from "./MTitle.vue?vue&type=template&id=5c99567e&scoped=true&"
import script from "./MTitle.vue?vue&type=script&lang=js&"
export * from "./MTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99567e",
  null
  
)

export default component.exports